import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { environment } from '@env/environment';
import { jwtInterceptor, serverErrorInterceptor } from '@lib/interceptors';
import { SessionMonitorService } from '@lib/services/session-monitor/session-monitor.service';
import {
    AppSessionEffects,
    appSessionReducer,
    hydrateAppSession,
    StudentRegistrationEffects,
    studentRegistrationReducer,
} from '@lib/store';
import { isValidSession } from '@lib/utils/auth/auth.utils';
import { storage } from '@lib/utils/storage/storage.utils';
import { provideEffects } from '@ngrx/effects';
import { provideStore, Store } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([serverErrorInterceptor, jwtInterceptor])),
        provideStore({
            appSession: appSessionReducer,
            studentRegistration: studentRegistrationReducer,
        }),
        provideEffects([AppSessionEffects, StudentRegistrationEffects]),
        provideStoreDevtools({ maxAge: 25, logOnly: false }),
        provideAppInitializer(() => {
            const store = inject(Store);
            const sessionMonitor = inject(SessionMonitorService);

            const session = storage.getItem('appSession');
            if (session) {
                if (isValidSession(session)) {
                    store.dispatch(hydrateAppSession({ session }));
                } else {
                    storage.removeItem('appSession');
                }
            }

            // Initialize session monitoring (this starts the service)
            sessionMonitor.validateSession();

            return Promise.resolve();
        }),
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.RECAPTCHA_SITE_KEY,
        },
    ],
};
